module.exports = __webpack_public_path__ + "static/media/DSC01503.d670b72d.jpg";